var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"search__button",attrs:{"type":"is-primary","icon-left":"magnify","disabled":_vm.$attrs.disabled},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('search')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }